import config from "../config";
export const main = {
  en: {
    "main.hero.title":
      "The right place for online trading on financial markets",
    "main.hero.subtitle":
      "The most convenient interface Get access to trade over 100 global trading assets",
    "main.hero.button": "Start in one click",
    "main.conditions.title": "Place your trades on best conditions",
    "main.conditions.i-1": "Minimum investment amount",
    "main.conditions.i-2": "Minimum trade amount",
    "main.conditions.i-3": "Virtual money on your Demo account",
    "main.conditions.i-4": "Payment methods",
    "main.conditions.i-5": "No commission on deposit and withdrawal",
    "main.conditions.i-6": "Assets for trading",
    "main.why.title": "Assets for trading",
    "main.why.join_button": "Join now",
    "main.why.i-1_title": "Flexible Trading",
    "main.why.i-1_text":
      "Latest trends: quick and digital trading, express trades, leverage trading up to x100.",
    "main.why.i-1_button": "Try a demo account",
    "main.why.i-2_title": "Diverse Trading Instruments",
    "main.why.i-2_text":
      "Assets suitable for any trader: currency, commodities, stocks, cryptocurrencies.",
    "main.why.i-3_title": "Demo Account",
    "main.why.i-3_text":
      "Try all platform benefits on the Demo account using virtual money. No investment needed, no risks involved.",
    "main.why.i-4_title": "Easy Deposits And Withdrawals",
    "main.why.i-4_text":
      "Use cashback and other advantages for a more comfortable trading experience with minimal risks.",
    "main.why.i-5_title": "Trading Advantages",
    "main.why.i-5_text":
      "Use cashback and other advantages for a more comfortable trading experience with minimal risks.",
    "main.why.i-6_title": "Why Binary Options?",
    "main.why.i-6_text":
      "Your gateway to smart trading is here! Binary options combine simplicity with potential, offering a clear path to fast and profitable trades.",
    "main.why.i-7_title": "Why Trade Futures?",
    "main.why.i-7_text":
      "Amplify your potential with leveraged trading! Futures offer higher returns by allowing you to control larger positions with less capital.",
    "main.offer.title": "Test Your Luck!",
    "main.offer.text": `Enter your email address and get a special offer from ${config.default_title}. If the luck is on your side, you will receive a free gift!`,
    "main.offer.start": "Start in one click",

    "main.about_us": "About Us",
    "main.privacy_policy": "Privacy Policy",
    "main.cookie_policy": "Cookie Policy",
    "main.terms_of_use": "Terms of Use",
    "main.help_center": "Help Center",
    "main.faq": "FAQs",
    "main.aml_policy": "KYC/AML Policy",

    "main.footer.t1": "All Rights Reserved",
    "main.footer.t2": "General information",
    "main.footer.t3": "Technical support",
    "main.header.company": "Company",
    "main.header.aboutUs": "About Us",
    "main.header.benefit": "Benefit",
    "main.header.contactUs": "Contact Us",
    "main.header.logIn": "Log In",
    "main.header.signUp": "Sign Up",
    "main.hero.title1": "Innovative platform for crypto futures trading",
    "main.hero.subtitle1": "Trade",
    "main.hero.subtitle2": "like a professional together with",
    "main.hero.subtitle3": "Binify",
    "main.hero.description":
      "Traders from around the world choose Binify every day",
    "main.hero.learnMore": "Learn More",
    "main.hero.tryFreeDemo": "Try a demo account",
    "main.tradingExperience.title": "Why choose Binify",
    "main.tradingExperience.statistics": "Statistics:",
    "main.tradingExperience.maximumLeverage": "Maximum leverage",
    "main.tradingExperience.tradingPairs": "Trading pairs",
    "main.tradingExperience.customerCare": "Customer support",
    "main.whatWeOffer.title": "What we offer",
    "main.whatWeOffer.scrollJourney": "Scroll through the cards",
    "main.whatWeOffer.tradeFutures1": "Trade futures",
    "main.whatWeOffer.tradeFutures2": "without friction",
    "main.whatWeOffer.tradeFuturesDesc":
      "No hidden fees, no delays, no complexity.",
    "main.whatWeOffer.tradeFuturesButton": "Start trading instantly",
    "main.whatWeOffer.proGrade1": "Stay ahead with",
    "main.whatWeOffer.proGrade2": "pro-grade tools",
    "main.whatWeOffer.proGradeDesc":
      "Leverage real-time data and advanced charting to react faster, execute smarter, and gain the edge every trader needs.",
    "main.whatWeOffer.proGradeButton": "Unlock your edge",
    "main.whatWeOffer.security1": "Security you",
    "main.whatWeOffer.security2": "can trust",
    "main.whatWeOffer.securityDesc":
      "We use modern security tools to ensure the platform operates reliably and securely",
    "main.whatWeOffer.securityDescFull":
      "We use modern security tools to ensure the platform operates reliably and securely.",
    "main.whatWeOffer.breachLosses": "Breach losses",
    "main.whatWeOffer.systemUptime": "System uptime",
    "main.whatWeOffer.dataEncryption": "Data encryption",
    "main.whatWeOffer.custodyPartners": "Custody partners",
    "main.features.fastExecution": "Fast execution and liquidity",
    "main.features.fastExecutionDesc":
      "Instant trade execution with access to deep market liquidity...",
    "main.features.smartSupport": "Smart and reliable support",
    "main.features.smartSupportDesc": "Instant Support Available Anytime",
    "main.features.flexibleCapital": "Flexible capital management",
    "main.features.skillBuilding": "Knowledge base for learning",
    "main.testimonials.title": "What our traders say",
    "main.testimonials.quote1":
      "\"Binify is the most user-friendly platform I've used. Fast deposits and support that actually replies. Feels like it's built for real traders.\"",
    "main.testimonials.quote2":
      '"Super-fast order execution and a very intuitive interface. The best part - support is always available and actually helps."',
    "main.testimonials.quote3":
      '"I really like the analytics and risk management tools. They let me focus only on my strategy instead of technical issues."',
    "main.testimonials.experience1": "3 years of experience",
    "main.testimonials.experience2": "7 years of experience",
    "main.testimonials.experience3": "4 years of experience",
    "main.stillThinking.title": "Still thinking?",
    "main.stillThinking.subtitle":
      "Just three simple steps to register, start trading and claim your free gift",
    "main.stillThinking.step1Title": "Create your account",
    "main.stillThinking.step1Desc":
      "Open your trading account with just a few taps",
    "main.stillThinking.step2Title": "Fund your wallet",
    "main.stillThinking.step2Desc":
      "Make a quick deposit using our trusted payment methods and get.",
    "main.stillThinking.step3Title": "Start trading",
    "main.stillThinking.step3Desc":
      "Access powerful tools and trade real assets with high liquidity and returns",
    "main.cta.text":
      "Join our platform and access deep liquidity, advanced tools, and reliable support.",
    "main.cta.tryFreeDemo": "Try free demo",
    "main.footer.rights": "Binify 2025. All rights reserved.",
    "main.footer.generalInfo": "General information:",
    "main.footer.technicalSupport": "Technical support:",
    "main.footer.privacyPolicy": "Privacy policy",
    "main.footer.termsOfUse": "Terms of use",
    "main.footer.kycAmlPolicy": "KYC/AML policy",
    "main.footer.cookiePolicy": "Cookie policy",
    "main.footer.information": "Information:",
    "main.footer.support": "Support:",
    "main.testimonials.maksym": "Maksym K.",
    "main.testimonials.maria": "Maria L.",
    "main.testimonials.oleksandr": "Oleksandr K.",
  },

  ru: {
    "main.hero.title":
      "Лучшая пратформа для онлайн-торговли на финансовых рынках",
    "main.hero.subtitle":
      "Самый удобный интерфейс. Получите доступ к торговле более чем 100 мировыми торговыми активами.",
    "main.hero.button": "Начните в один клик",
    "main.conditions.title": "Начинайте свои сделки на лучших условиях",
    "main.conditions.i-1": "Минимальная сумма инвестиций",
    "main.conditions.i-2": "Минимальная сумма сделки",
    "main.conditions.i-3": "Виртуальные средства на вашем учебном счете",
    "main.conditions.i-4": "Способы оплаты",
    "main.conditions.i-5": "Отсутствие комиссии на ввод и вывод средств",
    "main.conditions.i-6": "Активы для торговли",
    "main.why.title": "Активы для торговли",
    "main.why.join_button": "Присоединиться сейчас",
    "main.why.i-1_title": "Гибкая торговля",
    "main.why.i-1_text":
      "Последние тенденции: быстрая и цифровая торговля, экспресс-торговля, торговля с плечом до х100.",
    "main.why.i-1_button": "Попробовать демо-аккаунт",
    "main.why.i-2_title": "Разнообразные торговые инструменты",
    "main.why.i-2_text":
      "Наборы, подходящие для любого трейдера: валюта, сырьевые товары, акции, криптовалюты.",
    "main.why.i-3_title": "Демо счет",
    "main.why.i-3_text":
      "Попробуйте все преимущества платформы на демо-счете, используя виртуальные деньги. Никаких инвестиций, никаких рисков.",
    "main.why.i-4_title": "Легкие депозиты и снятие средств",
    "main.why.i-4_text":
      "Используйте кэшбэк и другие преимущества для более комфортной торговли с минимальными рисками.",
    "main.why.i-5_title": "Торговые преимущества",
    "main.why.i-5_text":
      "Используйте кэшбэк и другие преимущества для более комфортной торговли с минимальными рисками.",
    "main.why.i-6_title": "Почему бинарные опционы?",
    "main.why.i-6_text":
      "Ваш путь к умной торговле уже здесь! Бинарные опционы сочетают простоту с потенциалом, предоставляя понятный способ быстрого и прибыльного трейдинга.",
    "main.why.i-7_title": "Почему торговать фьючерсами?",
    "main.why.i-7_text":
      "Увеличьте свои возможности с торговлей с плечом!\n" +
      "Фьючерсы предлагают более высокую доходность, позволяя управлять большими позициями при меньших затратах капитала.",
    "main.offer.title": "Проверьте свою удачу!",
    "main.offer.text": `Введите свой адрес электронной почты и получите специальное предложение от ${config.default_title}. Если удача будет на вашей стороне, вы получите подарок!`,
    "main.offer.start": "Начните в один клик",

    "main.about_us": "О нас",
    "main.privacy_policy": "Политика конфиденциальности",
    "main.cookie_policy": "Политика использования файлов Cookie",
    "main.terms_of_use": "Условия использования",
    "main.help_center": "Поддержка",
    "main.faq": "Часто задаваемые вопросы",
    "main.aml_policy": "Политика KYC/AML",

    "main.footer.t1": "Все права защищены",
    "main.footer.t2": "Общая информация",
    "main.footer.t3": "Техническая поддержка",
    "main.header.company": "Компания",
    "main.header.aboutUs": "О нас",
    "main.header.benefit": "Преимущества",
    "main.header.contactUs": "Контакты",
    "main.header.logIn": "Войти",
    "main.header.signUp": "Регистрация",
    "main.hero.title1": "Инновационная платформа для торговли криптофьючерсами",
    "main.hero.subtitle1": "Торгуйте",
    "main.hero.subtitle2": "как профессионал вместе с",
    "main.hero.subtitle3": "Binify",
    "main.hero.description":
      "Трейдеры со всего мира выбирают Binify каждый день",
    "main.hero.learnMore": "Узнать больше",
    "main.hero.tryFreeDemo": "Попробовать демо-счёт",
    "main.tradingExperience.title": "Почему выбирают Binify",
    "main.tradingExperience.statistics": "Статистика:",
    "main.tradingExperience.maximumLeverage": "Максимальное кредитное плечо",
    "main.tradingExperience.tradingPairs": "Торговых пар",
    "main.tradingExperience.customerCare": "Служба поддержки",
    "main.whatWeOffer.title": "Что мы предлагаем",
    "main.whatWeOffer.scrollJourney": "Прокручивай карточки",
    "main.whatWeOffer.tradeFutures1": "Торгуйте фьючерсами",
    "main.whatWeOffer.tradeFutures2": "без помех",
    "main.whatWeOffer.tradeFuturesDesc":
      "Без скрытых комиссий, без задержек, без сложности.",
    "main.whatWeOffer.tradeFuturesButton": "Начните торговать сейчас",
    "main.whatWeOffer.proGrade1": "Оставайтесь впереди с",
    "main.whatWeOffer.proGrade2": "профессиональными инструментами",
    "main.whatWeOffer.proGradeDesc":
      "Используйте данные в реальном времени и расширенную графику, чтобы реагировать быстрее, выполнять умнее и получать преимущество, необходимое каждому трейдеру.",
    "main.whatWeOffer.proGradeButton": "Разблокируйте свое преимущество",
    "main.whatWeOffer.security1": "Безопасность, которой",
    "main.whatWeOffer.security2": "можно доверять",
    "main.whatWeOffer.securityDesc":
      "Мы используем современные инструменты защиты, чтобы обеспечить стабильную и безопасную работу платформы",
    "main.whatWeOffer.securityDescFull":
      "Мы используем современные инструменты защиты, чтобы обеспечить стабильную и безопасную работу платформы.",
    "main.whatWeOffer.breachLosses": "Потери от изломов",
    "main.whatWeOffer.systemUptime": "Бесперебойной работы системы",
    "main.whatWeOffer.dataEncryption": "Защита данных",
    "main.whatWeOffer.custodyPartners": "Кастодиальные партнёры",
    "main.features.fastExecution": "Быстрое исполнение и ликвидность",
    "main.features.fastExecutionDesc":
      "Мгновенное выполнение сделок с доступом к глубокой рыночной ликвидности...",
    "main.features.smartSupport": "Умная и надёжная поддержка",
    "main.features.smartSupportDesc":
      "Мгновенная поддержка доступна в любое время",
    "main.features.flexibleCapital": "Гибкое управление капиталом",
    "main.features.skillBuilding": "База знаний для обучения",
    "main.testimonials.title": "Что говорят наши трейдеры",
    "main.testimonials.quote1":
      '"Binify - самая удобная платформа, которую я когда-либо использовал. Быстрые депозиты и поддержка, которая реально отвечает. Чувствуется, что она создана для настоящих трейдеров."',
    "main.testimonials.quote2":
      '"Супербыстрое выполнение ордеров и очень интуитивный интерфейс. Лучшая часть - поддержка всегда доступна и реально помогает."',
    "main.testimonials.quote3":
      '"Мне очень нравятся инструменты аналитики и управления рисками. Они позволяют мне сосредоточиться только на своей стратегии вместо технических проблем."',
    "main.testimonials.experience1": "3 года опыта",
    "main.testimonials.experience2": "7 лет опыта",
    "main.testimonials.experience3": "4 года опыта",
    "main.stillThinking.title": "Всё ещё думаешь?",
    "main.stillThinking.subtitle":
      "Всего три простых шага для регистрации, начала торговли и получения бесплатного подарка",
    "main.stillThinking.step1Title": "Создайте свой аккаунт",
    "main.stillThinking.step1Desc":
      "Откройте торговый аккаунт всего несколькими нажатиями",
    "main.stillThinking.step2Title": "Пополните кошелек",
    "main.stillThinking.step2Desc":
      "Сделайте быстрый депозит, используя наши надежные способы оплаты.",
    "main.stillThinking.step3Title": "Начните торговать",
    "main.stillThinking.step3Desc":
      "Получите доступ к мощным инструментам и торгуйте реальными активами с высокой ликвидностью и доходностью",
    "main.cta.text":
      "Присоединяйтесь к нашей платформе и получите доступ к глубокой ликвидности, расширенным инструментам и надежной поддержке.",
    "main.cta.tryFreeDemo": "Попробовать бесплатную демо",
    "main.footer.rights": "Binify 2025. Все права защищены.",
    "main.footer.generalInfo": "Общая информация:",
    "main.footer.technicalSupport": "Техническая поддержка:",
    "main.footer.privacyPolicy": "Политика конфиденциальности",
    "main.footer.termsOfUse": "Условия использования",
    "main.footer.kycAmlPolicy": "Политика KYC/AML",
    "main.footer.cookiePolicy": "Политика файлов cookie",
    "main.footer.information": "Информация:",
    "main.footer.support": "Поддержка:",
    "main.testimonials.maksym": "Максим К.",
    "main.testimonials.maria": "Мария Л.",
    "main.testimonials.oleksandr": "Александр К.",
  },

  es: {
    "main.hero.title":
      "El lugar adecuado para operar en línea en los mercados financieros",
    "main.hero.subtitle":
      "La interfaz más conveniente para acceder a más de 100 activos de trading globales",
    "main.hero.button": "Comenzar en un clic",
    "main.conditions.title":
      "Realiza tus operaciones en las mejores condiciones",
    "main.conditions.i-1": "Cantidad mínima de inversión",
    "main.conditions.i-2": "Cantidad mínima de operación",
    "main.conditions.i-3": "Dinero virtual en tu cuenta demo",
    "main.conditions.i-4": "Métodos de pago",
    "main.conditions.i-5": "Sin comisión en depósito y retiro",
    "main.conditions.i-6": "Activos para trading",
    "main.why.title": "Activos para trading",
    "main.why.i-1_title": "Trading flexible",
    "main.why.i-1_text":
      "Últimas tendencias: trading rápido y digital, operaciones exprés, forex mt5, órdenes pendientes, copia de operaciones. Pagos de hasta un 218%.",
    "main.why.i-2_title": "Instrumentos de trading diversos",
    "main.why.i-2_text":
      "Activos adecuados para cualquier trader: divisas, materias primas, acciones, criptomonedas.",
    "main.why.i-3_title": "Cuenta demo",
    "main.why.i-3_text":
      "Prueba todos los beneficios de la plataforma en la cuenta demo utilizando dinero virtual. No se necesita inversión, no hay riesgos involucrados.",
    "main.why.i-4_title": "Depósitos y retiros fáciles",
    "main.why.i-4_text":
      "Utiliza el cashback y otras ventajas para una experiencia de trading más cómoda con riesgos mínimos.",
    "main.why.i-5_title": "Ventajas del trading",
    "main.why.i-5_text":
      "Utiliza el cashback y otras ventajas para una experiencia de trading más cómoda con riesgos mínimos.",
    "main.offer.title": "¡Prueba tu suerte!",
    "main.offer.text": `Ingresa tu dirección de correo electrónico y recibe una oferta especial de ${config.default_title}. Si la suerte está de tu lado, ¡recibirás un regalo gratis!`,
    "main.offer.start": "Comenzar en un clic",

    "main.about_us": "Sobre Nosotros",
    "main.privacy_policy": "Política de Privacidad",
    "main.cookie_policy": "Política de Cookies",
    "main.terms_of_use": "Términos de Uso",
    "main.help_center": "Centro de Ayuda",
    "main.faq": "Preguntas Frecuentes",
    "main.aml_policy": "Política KYC/AML",

    "main.footer.t1": "Todos los derechos reservados",
    "main.footer.t2": "Información general",
    "main.footer.t3": "Soporte técnico",
    "main.header.company": "Compañía",
    "main.header.aboutUs": "Sobre Nosotros",
    "main.header.benefit": "Beneficio",
    "main.header.contactUs": "Contáctanos",
    "main.header.logIn": "Iniciar sesión",
    "main.header.signUp": "Registrarse",
    "main.hero.title1":
      "Plataforma innovadora para operar con futuros de criptomonedas",
    "main.hero.subtitle1": "Opera",
    "main.hero.subtitle2": "como un profesional junto con",
    "main.hero.subtitle3": "Binify",
    "main.hero.description":
      "Los traders de todo el mundo eligen Binify cada día",
    "main.hero.learnMore": "Aprende más",
    "main.hero.tryFreeDemo": "Probar una cuenta demo",
    "main.tradingExperience.title": "Por qué elegir Binify",
    "main.tradingExperience.statistics": "Estadísticas:",
    "main.tradingExperience.maximumLeverage": "Apalancamiento máximo",
    "main.tradingExperience.tradingPairs": "Pares de trading",
    "main.tradingExperience.customerCare": "Atención al cliente",
    "main.whatWeOffer.title": "Lo que ofrecemos",
    "main.whatWeOffer.scrollJourney": "Desplázate por las tarjetas",
    "main.whatWeOffer.tradeFutures1": "Opera futuros",
    "main.whatWeOffer.tradeFutures2": "sin fricción",
    "main.whatWeOffer.tradeFuturesDesc":
      "Sin comisiones ocultas, sin retrasos, sin complejidad.",
    "main.whatWeOffer.tradeFuturesButton": "Comienza a operar instantáneamente",
    "main.whatWeOffer.proGrade1": "Mantente adelante con",
    "main.whatWeOffer.proGrade2": "herramientas de grado profesional",
    "main.whatWeOffer.proGradeDesc":
      "Aprovecha los datos en tiempo real y los gráficos avanzados para reaccionar más rápido, ejecutar de manera más inteligente y obtener la ventaja que todo trader necesita.",
    "main.whatWeOffer.proGradeButton": "Desbloquea tu ventaja",
    "main.whatWeOffer.security1": "Seguridad en la que",
    "main.whatWeOffer.security2": "puedes confiar",
    "main.whatWeOffer.securityDesc":
      "Utilizamos herramientas de seguridad modernas para garantizar el funcionamiento estable y seguro de la plataforma",
    "main.whatWeOffer.securityDescFull":
      "Utilizamos herramientas de seguridad modernas para garantizar el funcionamiento estable y seguro de la plataforma.",
    "main.whatWeOffer.breachLosses": "Pérdidas por infracciones",
    "main.whatWeOffer.systemUptime": "Tiempo de actividad del sistema",
    "main.whatWeOffer.dataEncryption": "Cifrado de datos",
    "main.whatWeOffer.custodyPartners": "Socios de custodia",
    "main.features.fastExecution": "Ejecución rápida y liquidez",
    "main.features.fastExecutionDesc":
      "Ejecución instantánea de operaciones con acceso a liquidez profunda del mercado...",
    "main.features.smartSupport": "Soporte inteligente y confiable",
    "main.features.smartSupportDesc":
      "Soporte Instantáneo Disponible en Cualquier Momento",
    "main.features.flexibleCapital": "Gestión flexible del capital",
    "main.features.skillBuilding": "Base de conocimientos para el aprendizaje",
    "main.testimonials.title": "Lo que dicen nuestros traders",
    "main.testimonials.quote1":
      '"Binify es la plataforma más fácil de usar que he usado. Depósitos rápidos y soporte que realmente responde. Se siente como si estuviera construida para traders reales."',
    "main.testimonials.quote2":
      '"Ejecución de órdenes súper rápida y una interfaz muy intuitiva. La mejor parte - el soporte siempre está disponible y realmente ayuda."',
    "main.testimonials.quote3":
      '"Realmente me gustan las herramientas de análisis y gestión de riesgos. Me permiten enfocarme solo en mi estrategia en lugar de problemas técnicos."',
    "main.testimonials.experience1": "3 años de experiencia",
    "main.testimonials.experience2": "7 años de experiencia",
    "main.testimonials.experience3": "4 años de experiencia",
    "main.stillThinking.title": "¿Aún lo estás pensando?",
    "main.stillThinking.subtitle":
      "Solo tres pasos simples para registrarse, comenzar a operar y reclamar tu regalo gratis",
    "main.stillThinking.step1Title": "Crea tu cuenta",
    "main.stillThinking.step1Desc":
      "Abre tu cuenta de trading con solo unos toques",
    "main.stillThinking.step2Title": "Fondos tu billetera",
    "main.stillThinking.step2Desc":
      "Haz un depósito rápido usando nuestros métodos de pago confiables y obtén.",
    "main.stillThinking.step3Title": "Comienza a operar",
    "main.stillThinking.step3Desc":
      "Accede a herramientas poderosas y opera activos reales con alta liquidez y retornos",
    "main.cta.text":
      "Únete a nuestra plataforma y accede a liquidez profunda, herramientas avanzadas y soporte confiable.",
    "main.cta.tryFreeDemo": "Prueba demo gratis",
    "main.footer.rights": "Binify 2025. Todos los derechos reservados.",
    "main.footer.generalInfo": "Información general:",
    "main.footer.technicalSupport": "Soporte técnico:",
    "main.footer.privacyPolicy": "Política de privacidad",
    "main.footer.termsOfUse": "Términos de uso",
    "main.footer.kycAmlPolicy": "Política KYC/AML",
    "main.footer.cookiePolicy": "Política de cookies",
    "main.footer.information": "Información:",
    "main.footer.support": "Soporte:",
    "main.testimonials.maksym": "Maksym K.",
    "main.testimonials.maria": "María L.",
    "main.testimonials.oleksandr": "Oleksandr K.",
  },

  ua: {
    "main.hero.title":
      "Правильне місце для онлайн-торгівлі на фінансових ринках",
    "main.hero.subtitle":
      "Найзручніший інтерфейс. Отримайте доступ до торгівлі понад 100 світовими активами",
    "main.hero.button": "Почати в один клік",

    "main.conditions.title": "Розміщуйте свої угоди на найкращих умовах",
    "main.conditions.i-1": "Мінімальна сума інвестицій",
    "main.conditions.i-2": "Мінімальна сума угоди",
    "main.conditions.i-3": "Віртуальні гроші на вашому демо-рахунку",
    "main.conditions.i-4": "Методи оплати",
    "main.conditions.i-5": "Без комісії за депозит і зняття",
    "main.conditions.i-6": "Активи для торгівлі",

    "main.why.title": "Активи для торгівлі",
    "main.why.join_button": "Приєднатися зараз",
    "main.why.i-1_title": "Гнучка торгівля",
    "main.why.i-1_text":
      "Останні тренди: швидка та цифрова торгівля, експрес-угоди, торгівля з кредитним плечем до x100.",
    "main.why.i-1_button": "Спробувати демо-рахунок",
    "main.why.i-2_title": "Різноманітні торгові інструменти",
    "main.why.i-2_text":
      "Активи, що підходять для будь-якого трейдера: валюти, товари, акції, криптовалюти.",
    "main.why.i-3_title": "Демо-рахунок",
    "main.why.i-3_text":
      "Спробуйте всі переваги платформи на демо-рахунку з віртуальними грошима. Жодних інвестицій, жодних ризиків.",
    "main.why.i-4_title": "Прості депозити та зняття коштів",
    "main.why.i-4_text":
      "Використовуйте кешбек та інші переваги для комфортної торгівлі з мінімальними ризиками.",
    "main.why.i-5_title": "Переваги торгівлі",
    "main.why.i-5_text":
      "Використовуйте кешбек та інші переваги для комфортної торгівлі з мінімальними ризиками.",
    "main.why.i-6_title": "Чому бінарні опціони?",
    "main.why.i-6_text":
      "Ваш шлях до розумної торгівлі тут! Бінарні опціони поєднують простоту з потенціалом, пропонуючи чіткий шлях до швидких і прибуткових угод.",
    "main.why.i-7_title": "Чому торгувати ф’ючерсами?",
    "main.why.i-7_text":
      "Збільшуйте свій потенціал за допомогою торгівлі з кредитним плечем! Ф’ючерси пропонують вищий прибуток, дозволяючи контролювати більші позиції з меншим капіталом.",

    "main.offer.title": "Спробуйте удачу!",
    "main.offer.text": `Введіть вашу електронну адресу та отримайте спеціальну пропозицію від ${config.default_title}. Якщо удача на вашому боці, ви отримаєте безкоштовний подарунок!`,
    "main.offer.start": "Почати в один клік",

    "main.about_us": "Про нас",
    "main.privacy_policy": "Політика конфіденційності",
    "main.cookie_policy": "Політика cookie",
    "main.terms_of_use": "Умови використання",
    "main.help_center": "Центр підтримки",
    "main.faq": "Питання та відповіді",
    "main.aml_policy": "Політика KYC/AML",

    "main.footer.t1": "Всі права захищені",
    "main.footer.t2": "Загальна інформація",
    "main.footer.t3": "Технічна підтримка",

    "main.hero.title1": "Інноваційна платформа для торгівлі криптоф’ючерсами",
    "main.hero.subtitle1": "Торгуйте",
    "main.hero.subtitle2": "як професіонал разом із",
    "main.hero.subtitle3": "Binify",
    "main.hero.description": "Трейдери з усього світу обирають Binify щодня",
    "main.hero.learnMore": "Дізнатися більше",
    "main.hero.tryFreeDemo": "Спробувати демо-рахунок",
    "main.tradingExperience.title": "Чому обирають Binify",
    "main.tradingExperience.statistics": "Статистика:",
    "main.tradingExperience.maximumLeverage": "Максимальне кредитне плече",
    "main.tradingExperience.tradingPairs": "Торгових пар",
    "main.tradingExperience.customerCare": "Відділ турботи",
    "main.whatWeOffer.title": "Що ми пропонуємо",
    "main.whatWeOffer.scrollJourney": "Прокручуй картки",
    "main.whatWeOffer.tradeFutures1": "Торгуйте ф'ючерсами",
    "main.whatWeOffer.tradeFutures2": "без перешкод",
    "main.whatWeOffer.tradeFuturesDesc":
      "Жодних прихованих комісій, жодних затримок, жодної складності.",
    "main.whatWeOffer.tradeFuturesButton": "Почати торгувати зараз",
    "main.whatWeOffer.proGrade1": "Будьте на",
    "main.whatWeOffer.proGrade2": "крок попереду",
    "main.whatWeOffer.proGradeDesc":
      "Дані в реальному часі та надійна аналітика графіків допоможуть приймати точні рішення, діяти швидше й отримувати стабільну перевагу на ринку.",
    "main.whatWeOffer.proGradeButton": "Відкрити свої переваги",
    "main.whatWeOffer.security1": "Ваші кошти",
    "main.whatWeOffer.security2": "під захистом",
    "main.whatWeOffer.securityDesc":
      "Ми використовуємо сучасні інструменти захисту, щоб забезпечити стабільну та безпечну роботу платформи",
    "main.whatWeOffer.securityDescFull":
      "Ми використовуємо сучасні інструменти захисту, щоб забезпечити стабільну та безпечну роботу платформи.",
    "main.whatWeOffer.breachLosses": "Втрати від зламів",
    "main.whatWeOffer.systemUptime": "Безперервної роботи",
    "main.whatWeOffer.dataEncryption": "Захист даних",
    "main.whatWeOffer.custodyPartners": "Кастодіальні партнери",
    "main.features.fastExecution": "Швидке виконання та ліквідність",
    "main.features.fastExecutionDesc":
      "Миттєве виконання угод із доступом до глибокої ринкової ліквідності.",
    "main.features.smartSupport": "Розумна та надійна підтримка",
    "main.features.smartSupportDesc": "Миттєва підтримка у будь-який момент.",
    "main.features.flexibleCapital": "Гнучке керування капіталом",
    "main.features.skillBuilding": "База знань для навчання",
    "main.testimonials.title": "Що кажуть наші трейдери",
    "main.testimonials.quote1":
      '"Binify - найзручніша платформа, яку я коли-небудь використовував. Швидкі депозити та підтримка, яка реально відповідає."',
    "main.testimonials.quote2":
      '"Надзвичайно швидке виконання ордерів та дуже інтуїтивний інтерфейс. Найкраще - підтримка завжди доступна і реально допомагає."',
    "main.testimonials.quote3":
      '"Мені дуже подобаються інструменти аналітики та управління ризиками. Вони дозволяють мені зосередитися лише на своїй стратегії замість технічних проблем."',
    "main.testimonials.experience1": "3 роки досвіду",
    "main.testimonials.experience2": "7 років досвіду",
    "main.testimonials.experience3": "4 роки досвіду",
    "main.stillThinking.title": "Все ще думаєш?",
    "main.stillThinking.subtitle":
      "Лише три прості кроки, щоб зареєструватися, почати торгувати й отримати свій подарунок.",
    "main.stillThinking.step1Title": "Створіть аканут",
    "main.stillThinking.step1Desc":
      "Відкрийте торговий рахунок у кілька кліків.",
    "main.stillThinking.step2Title": "Поповніть гаманець",
    "main.stillThinking.step2Desc":
      "Зробіть швидкий депозит через надійні платіжні методи та підготуйтеся до старту.",
    "main.stillThinking.step3Title": "Почніть торгувати",
    "main.stillThinking.step3Desc":
      "Доступ до ринку з професійними інструментами та високою ліквідністю.",
    "main.cta.text":
      "Приєднуйтесь до нашої платформи та отримайте доступ до глибокої ліквідності, передових інструментів і надійної підтримки.",
    "main.cta.tryFreeDemo": "Почати торгувати зараз",
    "main.footer.rights": "Binify 2025. Всі права захищені.",
    "main.footer.generalInfo": "Загальна інформація:",
    "main.footer.technicalSupport": "Технічна підтримка:",
    "main.footer.privacyPolicy": "Політика конфіденційності",
    "main.footer.termsOfUse": "Умови використання",
    "main.footer.kycAmlPolicy": "Політика KYC/AML",
    "main.footer.cookiePolicy": "Політика файлів Cookie",
    "main.footer.information": "Інформація:",
    "main.footer.support": "Підтримка:",
    "main.header.company": "Компанія",
    "main.header.aboutUs": "Про нас",
    "main.header.benefit": "Переваги",
    "main.header.contactUs": "Контакти",
    "main.header.logIn": "Увійти",
    "main.header.signUp": "Реєстрація",
    "main.testimonials.maksym": "Максим К.",
    "main.testimonials.maria": "Марія Л.",
    "main.testimonials.oleksandr": "Олександр К.",
  },
};

export default main;
